import React from "react";
import "./assets/css/styles.scss";

const LatestUpdates = props => {
  const { data } = props;
  return (
    <div
      className="pr-3 overflow-auto w-100 latestupdate"
    >
      {data.map((item,key) => {
        let ts = new Date(item.created_at).toGMTString();
        let date = ts.slice(0, ts.length - 12).trim();
        return (
          item.body && <div className="my-3" key={key}>
            <div className="row h5">
              <div className="col-md-5">
                <h5><i className='feather icon-calendar pr-1' />{date}</h5>
              </div>
              <div
                className={`text-white text-center mt-n1 ml-n3 bg-${item.category.color} px-2 rounded-pill categoty-name`}
                size="sm"
              >
                <p>{item.category.name}</p>
              </div>
            </div>
            <div className="col-md-12 mt-3 ml-n3">
              <p>{item.body}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LatestUpdates;
